/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SearchResult } from './searchResult';

export interface SearchResponse { 
    total_matches_count: number;
    search_results: Array<SearchResult>;
}